module.exports = __webpack_public_path__ + "static/media/quarteto_coliseu_4.811c1834.jpg";